export const esNavigation = {
  'navigation.account': 'Cuenta',
  'navigation.accountOptions': 'Opciones de cuenta',
  'navigation.add': 'Agregar',
  'navigation.agenda': 'Agenda',
  'navigation.annual': 'Anual',
  'navigation.admin': 'Administración',
  'navigation.banks': 'Bancos',
  'navigation.calendar': 'Calendario',
  'navigation.changeLight': 'Cambiar a tema claro',
  'navigation.changeDark': 'Cambiar a tema oscuro',
  'navigation.finance': 'Finanzas',
  'navigation.filters': 'Filtros',
  'navigation.home': 'Inicio',
  'navigation.main': 'Navegación principal',
  'navigation.menu': 'Abrir menú',
  'navigation.notifications': 'Ver notificaciones',
  'navigation.notificationsUnread': 'Ver notificaciones, {count} sin leer',
  'navigation.plan': 'Plan',
  'navigation.plans': 'Planes',
  'navigation.quick': 'Rápido',
  'navigation.simulate': 'Simular',
  'navigation.referrals': 'Referidos',
  'navigation.settings': 'Ajustes',
  'navigation.sharedAccount': 'Cuenta compartida',
  'navigation.sidebar': 'Menú lateral',
  'navigation.support': 'Soporte',
  'navigation.tools': 'Herramientas',
  'navigation.wallets': 'Wallets',
} as const;

export const enNavigation: Record<keyof typeof esNavigation, string> = {
  'navigation.account': 'Account',
  'navigation.accountOptions': 'Account options',
  'navigation.add': 'Add',
  'navigation.agenda': 'Agenda',
  'navigation.annual': 'Annual',
  'navigation.admin': 'Administration',
  'navigation.banks': 'Banks',
  'navigation.calendar': 'Calendar',
  'navigation.changeLight': 'Switch to light theme',
  'navigation.changeDark': 'Switch to dark theme',
  'navigation.finance': 'Finances',
  'navigation.filters': 'Filters',
  'navigation.home': 'Home',
  'navigation.main': 'Main navigation',
  'navigation.menu': 'Open menu',
  'navigation.notifications': 'View notifications',
  'navigation.notificationsUnread': 'View notifications, {count} unread',
  'navigation.plan': 'Plan',
  'navigation.plans': 'Plans',
  'navigation.quick': 'Quick',
  'navigation.simulate': 'Simulate',
  'navigation.referrals': 'Referrals',
  'navigation.settings': 'Settings',
  'navigation.sharedAccount': 'Shared account',
  'navigation.sidebar': 'Sidebar menu',
  'navigation.support': 'Support',
  'navigation.tools': 'Tools',
  'navigation.wallets': 'Wallets',
};
